"use strict";
const $ = jQuery;
//blog listing slider
$(document).ready(function(){

  function openSearch(value = "") {
  const $summary = $("summary.header__icon--search").first();
  const $input = $(".search-modal .search__input").first();

  if (!$summary.length || !$input.length) return;

  const $details = $summary.closest("details");

  if (!$details.attr("open")) {
    $summary.trigger("click");
  }

  setTimeout(function () {
    $input
      .val(value)
      .trigger("input")
      .focus();
  }, 100);
}

  $('.as-accordion__toggle').click(function(e){

    if($(this).hasClass('active')){
      $('.as-accordion__content.active').removeClass('active')
      $('.as-accordion__toggle.active').removeClass('active')
    }
    else {
      $('.as-accordion__content.active').removeClass('active')
      $('.as-accordion__toggle.active').removeClass('active')
      $(this).addClass('active')
      $(this).next().addClass('active')
    }

  });

  $(".as-search").on("click",function(e){
    openSearch("");
window.scrollTo(0, 0);
  })
  
   $(".buton-trigger").on("click",function(e){
     const value = $(e.target).closest(".not-custom").length ? "" : e.currentTarget.innerText + "";
    $("summary.header__icon--search").closest( "details" ).attr('open', true);
    $(".search-modal .search__input")
  .val(value)
  .trigger("input")
  .focus();
  })

    $("#shopify-section-template--28987412971853__e8988766-aeb0-4c7a-9023-38f3464cda9b .banner").on("click",function(e){
    const value = $(e.target).closest(".not-custom").length ? "" : e.currentTarget.innerText + "";
    $("summary.header__icon--search").closest( "details" ).attr('open', true);
    $(".search-modal .search__input")
  .val(value)
  .trigger("input")
  .focus();
  })

    $("#Slide-template--28987412971853__slideshow_nTNeVg-1").on("click",function(e){
    const value = $(e.target).closest(".not-custom").length ? "" : e.currentTarget.innerText + "";
    $("summary.header__icon--search").closest( "details" ).attr('open', true);
    $(".search-modal .search__input")
  .val(value)
  .trigger("input")
  .focus();
  })

    $("#Slide-template--28987412971853__slideshow_nTNeVg-2").on("click",function(e){
    const value = $(e.target).closest(".not-custom").length ? "" : e.currentTarget.innerText + "";
    $("summary.header__icon--search").closest( "details" ).attr('open', true);
    $(".search-modal .search__input")
  .val(value)
  .trigger("input")
  .focus();
  })

    $("#Slide-template--28987412971853__slideshow_nTNeVg-3").on("click",function(e){
    const value = $(e.target).closest(".not-custom").length ? "" : e.currentTarget.innerText + "";
    $("summary.header__icon--search").closest( "details" ).attr('open', true);
    $(".search-modal .search__input")
  .val(value)
  .trigger("input")
  .focus();
  })

    $("#Slide-template--28987412971853__slideshow_nTNeVg-4").on("click",function(e){
    const value = $(e.target).closest(".not-custom").length ? "" : e.currentTarget.innerText + "";
    $("summary.header__icon--search").closest( "details" ).attr('open', true);
    $(".search-modal .search__input")
  .val(value)
  .trigger("input")
  .focus();
  })

    $("#Slide-template--28987412971853__slideshow_zteEVD-1").on("click",function(e){
    const value = $(e.target).closest(".not-custom").length ? "" : e.currentTarget.innerText + "";
    $("summary.header__icon--search").closest( "details" ).attr('open', true);
    $(".search-modal .search__input")
  .val(value)
  .trigger("input")
  .focus();
  })

    $("#Slide-template--28987412971853__slideshow_zteEVD-2").on("click",function(e){
    const value = $(e.target).closest(".not-custom").length ? "" : e.currentTarget.innerText + "";
    $("summary.header__icon--search").closest( "details" ).attr('open', true);
    $(".search-modal .search__input")
  .val(value)
  .trigger("input")
  .focus();
  })

    $("#shopify-section-template--20787083575636__rich_text_76Fyg8 .button").on("click",function(e){
    const value = $(e.target).closest(".not-custom").length ? "" :"";
    $("summary.header__icon--search").closest( "details" ).attr('open', true);
    $(".search-modal .search__input")
  .val(value)
  .trigger("input")
  .focus();
  })

    $("#shopify-section-template--20787083575636__rich_text_MwqaUN .button").on("click",function(e){
    const value = $(e.target).closest(".not-custom").length ? "" :"";
    $("summary.header__icon--search").closest( "details" ).attr('open', true);
    $(".search-modal .search__input")
  .val(value)
  .trigger("input")
  .focus();
  })

      $("#shopify-section-template--28987413758285__multicolumn_BhfGdn .button").on("click",function(e){
    const value = $(e.target).closest(".not-custom").length ? "" :"";
    $("summary.header__icon--search").closest( "details" ).attr('open', true);
    $(".search-modal .search__input")
  .val(value)
  .trigger("input")
  .focus();
  })

      $("#Banner-template--20167814185300__c0f548bf-4dff-4ab7-bc0c-e132b26d4b2a").on("click",function(e){
    const value = $(e.target).closest(".not-custom").length ? "" : e.currentTarget.innerText + "";
    $("summary.header__icon--search").closest( "details" ).attr('open', true);
    $(".search-modal .search__input")
  .val(value)
  .trigger("input")
  .focus();
  })

$("#shopify-section-sections--28987414708557__announcement-bar").on("click", function(e) {
  $("summary.header__icon--search").closest("details").attr('open', true);
  $(".search-modal .search__input")
    .val("")
    .trigger("input")
    .focus();
});

      $("#Banner-template--25383650787668__image_banner_8ehCny").on("click",function(e){
    if (!$(e.target).closest(".not-custom").length) {
  window.open("/pages/formular-auto", "_self");
}
  })

        $("#Banner-template--25383650787668__image_banner_c6TXqe").on("click",function(e){
    if (!$(e.target).closest(".not-custom").length) {
  window.open("/pages/formular-auto", "_self");
}
  })
})

        $("#Banner-template--28607651414356__image_banner_Yfpnjz").on("click",function(e){
    if (!$(e.target).closest(".not-custom").length) {
  window.open("/pages/formular-auto", "_self");
}
  })

          $("#Banner-template--28607651414356__image_banner_RCgyVA").on("click",function(e){
    if (!$(e.target).closest(".not-custom").length) {
  window.open("/pages/formular-auto", "_self");
}
  })

          $("#Banner-template--23753419948372__e99b5d51-810c-431b-941a-4fd43d38d4a8").on("click",function(e){
    if (!$(e.target).closest(".not-custom").length) {
  window.open("/pages/formular-auto", "_self");
}
  })

          $("#Banner-template--23753419948372__image_banner_qwGtdU").on("click",function(e){
    if (!$(e.target).closest(".not-custom").length) {
  window.open("/pages/formular-auto", "_self");
}
  })

$("#Slide-template--29934569947469__slideshow_UEjwre-1")
  .css("cursor", "pointer")
  .on("click", function(e) {
    if (!$(e.target).closest(".not-custom").length) {
      window.open("https://europa.eu/youreurope/citizens/consumers/shopping/guarantees-returns/index_en.htm", "_blank", "noopener,noreferrer");
    }
  });